import { render, staticRenderFns } from "./AccessGroupTreeNode.vue?vue&type=template&id=8228902a&scoped=true"
import script from "./AccessGroupTreeNode.vue?vue&type=script&lang=js"
export * from "./AccessGroupTreeNode.vue?vue&type=script&lang=js"
import style0 from "./AccessGroupTreeNode.vue?vue&type=style&index=0&id=8228902a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8228902a",
  null
  
)

export default component.exports